module.exports = __webpack_public_path__ + "img/tshirt3.f32f5788.jpg";